// extracted by mini-css-extract-plugin
export default {"component":"thumbableServicePage__component___mGrCd","top":"thumbableServicePage__top___hfOSY","bottom":"thumbableServicePage__bottom___Q8Sw+ thumbableServicePage__top___hfOSY"};